<template>
<div id="webterminal" style="width: 100%; height: 600px"></div>
</template>
<script>
export default {
    methods: {
        loadJS(url, implementationCode, location) {
            try {
                var scriptTag = document.createElement("script");
                scriptTag.src = url;

                scriptTag.onload = implementationCode;
                scriptTag.onreadystatechange = implementationCode;
                location.appendChild(scriptTag);
            } catch (err) {
                console.log("EE", err);
            }
        },
        onScriptLoaded() {
            try {
                new MetaTraderWebTerminal( "webterminal", {
                version: 4,
                servers: ["FxView-Demo", "FxView-Live"],
                server: "FxView-Demo",
                utmSource: "fxview.com",
                startMode: "create_demo",
                language: "en",
                colorScheme: "black_on_white"
                });
                this.$router.replace({query: null})
            } catch (err) {
                console.log("EE", err);
            }
        },
    },
    created(){
        this.loadJS(
            "https://metatraderweb.app/trade/widget.js",
            this.onScriptLoaded,
            document.body
        );
    },
};
</script>
  


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/web_trade_link_new.vue